import { applyStartOfTurn } from "../economy";
import type { GameEvent, GameState, MoveResult, PlayerId } from "../types";
import { checkVictory } from "./helpers";

export function applyEndTurn(state: GameState): MoveResult {
  const nextPlayer: PlayerId = state.currentPlayer === "p1" ? "p2" : "p1";
  const nextDay = nextPlayer === "p1" ? state.currentDay + 1 : state.currentDay;
  const afterSwap: GameState = {
    ...state,
    currentPlayer: nextPlayer,
    currentDay: nextDay,
    units: state.units.map((u) => {
      if (u.owner !== nextPlayer) return u;
      const { unloadReady: _unloadReady, ...rest } = u;
      return { ...rest, hasMoved: false, hasAttacked: false };
    }),
  };
  const turnEvents: GameEvent[] = [
    {
      type: "turnEnded",
      player: state.currentPlayer,
      nextPlayer,
      currentDay: nextDay,
    },
  ];

  const { state: afterIncome, events: incomeEvents } = applyStartOfTurn(afterSwap);
  const next = { ...afterIncome, status: checkVictory(afterIncome) };
  return { state: next, events: [...turnEvents, ...incomeEvents] };
}
